import { Box } from "@chakra-ui/react";
import * as React from "react";

function ProcessingOfSoldProductsPreview() {
  return (
    <Box>
    </Box>
  );
}

export default ProcessingOfSoldProductsPreview;